module.exports = __webpack_public_path__ + "img/blog_content_banner.b7564e72.webp";